import React from 'react';
import { routeMappings } from '../../constants';
import ResetPasswordPage from './ResetPasswordPage';
import { withNoAuthentication } from '../../authentication/components/WithNoAuthentication';
import ForgotPasswordPage from './ForgotPasswordPage';
import LogOutPage from './LogOutPage';
import { withBasicDetails } from '../../base/components/WithBasicDetails';
import AutoLoginPage from '../../workflowConfigurablePages/components/AutoLoginPage';

const LoginPage = React.lazy(() => import('./LoginPage'));
const UserProfile = React.lazy(() => import('./UserProfilePage'));

const authSimplifiedRoutes = [
  {
    path: routeMappings['AUTH_LOGIN'],
    exact: true,
    component: withNoAuthentication(LoginPage),
    customProps: {
      pageName: 'signinSignupTitle',
    },
  },
  {
    path: routeMappings['AUTH_RESET_PASSWORD'],
    exact: true,
    component: ResetPasswordPage,
    customProps: {
      pageName: 'resetPassword',
    },
  },
  {
    path: routeMappings['AUTH_FORGOT_PASSWORD'],
    exact: true,
    component: withNoAuthentication(ForgotPasswordPage),
    customProps: {
      pageName: 'forgotPassword',
    },
  },
  {
    path: routeMappings['AUTH_LOGOUT'],
    exact: true,
    component: LogOutPage,
    customProps: {
      pageName: 'signOutTitle',
    },
  },
  {
    path: routeMappings['AUTH_USER_PROFILE'],
    exact: true,
    component: withBasicDetails(UserProfile),
    customProps: {
      pageName: 'userProfile',
    },
  },
  {
    /** TODO: change this route to /welcome only */
    path: routeMappings['AUTH_WELCOME'],
    exact: true,
    component: AutoLoginPage,
    customProps: {
      pageName: 'welcome',
    },
  },
];

export default authSimplifiedRoutes;
